
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Client, InvoiceBatchModel, IInvoiceBatchModel } from '@/services/api.service';
  import * as QueryUtils from '@/utilities/querystring.utils';
  import * as DateUtils from '@/utilities/date.utils';
  import * as log from 'loglevel';
  import moment from 'moment';
  import EditInvoiceBatch from '@/views/accounting/batches/edit/EditInvoiceBatch.vue';
  import { InvoiceBatchCreatedMessage, InvoiceBatchUpdatedMessage } from '@/services/eventbus.models';
  import toLocalDateFormatter from '@/filters/tolocaldate.formatter';


  export class BatchDetail implements IInvoiceBatchModel {
    public batchName: string | undefined = '';
    public gid: string | undefined = '';
    public openDateTimeUtc: Date | undefined = undefined;
    public closedDateTimeUtc: Date | undefined = undefined;
    public isDeleted?: boolean;
    public invoiceCount: number = 0;
    public clientName: string = '';
    public canEdit: boolean = false;
    public canClose: boolean = false;
    public canExport: boolean = false;
  }

  @Component({
    components: {
      EditInvoiceBatch
    },
    filters: {
      toLocalDate: toLocalDateFormatter
    }
  })
  export default class InvoiceBatchList extends Vue {
    // public searchCriteria: string = '';
    private includeClosedAndExported: boolean = false;
    private openedAfter: Date | null = null;
    private searchResults: BatchDetail[] = [];
    private selectedBatch: IInvoiceBatchModel | null = null;
    private isSearching: boolean = false;

    protected mounted() {
      // const q: string = this.$route.query.q as string;
      // const includeClosed: string = this.$route.query.includeClosed as string;
      // if (includeClosed !== null && includeClosed !== undefined) {
      //   try {
      //     this.includeClosedAndExported = JSON.parse(includeClosed);
      //   } catch (e) {
      //     this.includeClosedAndExported = false;
      //   }
      // }

      // const openedAfter: string = this.$route.query.openedAfter as string;
      // if (openedAfter !== null && openedAfter !== undefined) {
      //   try {
      //     const parsedDate = moment(openedAfter);
      //     if (parsedDate) {
      //       this.openedAfter = parsedDate.toDate();
      //     }
      //   } catch (e) {
      //     this.openedAfter = undefined;
      //   }
      // }

      // We execute the search on mounted if we
      // have parsed up any useful parameters
      this.searchBatches(true);
    }

    private searchBatches(bypassHistoryPush: boolean) {
      // if (this.includeClosedAndExported !== true || this.openedAfter !== null) {
      //   if (!bypassHistoryPush) {
      //     // Make sure that we have a new route, and aren't just pushing
      //     // the same old route query data onto the history, as that
      //     // gives some issues like navigation duplicated errors
      //     if (
      //       !QueryUtils.isQueryObjectMatch(this.$route.query, {
      //         includeClosed: this.includeClosedAndExported,
      //         openedAfter: DateUtils.toIso8601Date(this.openedAfter)
      //       })
      //     ) {
      //       console.log('Search pushing history:', {
      //         includeClosed: this.includeClosedAndExported,
      //         openedAfter: DateUtils.toIso8601Date(this.openedAfter)
      //       });
      //       this.$router.push({
      //         path: 'invoicebatches',
      //         query: {
      //           includeClosed: String(this.includeClosedAndExported),
      //           openedAfter: DateUtils.toIso8601Date(this.openedAfter)
      //         }
      //       });
      //       // If we are pushing the history, then by pushing it,
      //       // it will remount the view, which in turn will execute
      //       // the search. So we can bail out here and not continue
      //       // to execute the search as the mounted method will do so
      //       return;
      //     }
      //   }
      // @ts-ignore
      this.$Progress.start();
      this.isSearching = true;
      this.searchResults = [];
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      // let localOpenedAfter: Date | null = null;
      // if (this.openedAfter) {
      //   localOpenedAfter = moment(this.openedAfter).toDate();
      // }

      clientService
        .getInvoiceBatches(this.openedAfter || undefined, false, this.includeClosedAndExported)
        .then(data => {
          if (data !== null && data.length > 0) {
            // push the results into the list
            this.searchResults = data.map(item => this.invoiceBatchModelToBatchDetail(item));
          } else {
            // Pop some toast
            // @ts-ignore
            this.$awn.info('No matching invoice batches were found');
          }
          // @ts-ignore
          this.$Progress.finish();
          this.isSearching = false;
        })
        .catch((reason: any) => {
          this.isSearching = false;
          // @ts-ignore
          this.$Progress.finish();
          // @ts-ignore
          this.$awn.alert('An error occurred retrieving invoice batches');
        });
      // } else {
      //   // Empty search criteria, so toaster?
      // }
    }

    private invoiceBatchModelToBatchDetail(item: IInvoiceBatchModel): BatchDetail {
      const b = new BatchDetail();
      b.gid = item.gid;
      b.batchName = item.batchName;
      b.openDateTimeUtc = item.openDateTimeUtc;
      b.closedDateTimeUtc = item.closedDateTimeUtc;
      b.invoiceCount = item.invoiceCount || 0;
      b.clientName = item.clientName || '--';
      if (b.closedDateTimeUtc != null) {
        b.canEdit = false;
        b.canClose = false;
        b.canExport = true;
      } else {
        b.canEdit = true;
        b.canClose = true;
        b.canExport = false;
      }
      return b;
    }

    private onCreateInvoiceBatchRequested() {
      this.selectedBatch = null;
      this.$modal.show('modal-invoicebatch-edit');
    }

    private onInvoiceBatchCreated(message: InvoiceBatchCreatedMessage) {
      // Add the item to the list
      if (message && message.data) {
        this.searchResults.push(this.invoiceBatchModelToBatchDetail(message.data));
      }
    }
  }
